type CookieConsent = {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  hasResponse: boolean;
  isLoaded: boolean;
  isError: boolean;
};

export default defineNuxtPlugin({
  parallel: true,
  name: "consent",
  dependsOn: ["platform"],
  setup: () => {
    const { getPlatformConfiguration } = usePlatformStore();
    const { cookieBotKey } = getPlatformConfiguration;
    const isLiverpool = getIsHostLiverpool();
    const isProductionApp = useIsProductionApp();

    if (!isLiverpool && !isProductionApp && !cookieBotKey) {
      // local setup without cookiebot
      return {
        provide: {
          cookieConsent: {
            consent: reactive({
              necessary: true,
              preferences: true,
              statistics: true,
              marketing: true,
              hasResponse: true,
              isLoaded: true,
              isError: false,
            }),
            renew: () => {},
          },
        },
      };
    }

    const cookieConsent: CookieConsent = reactive({
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false,
      hasResponse: false,
      isLoaded: false,
      isError: false,
    });

    const renew = () => {
      if (isLiverpool) {
        if ("OneTrust" in window) (window.OneTrust as any)?.ToggleInfoDisplay();

        return;
      }

      if ("renew" in (window as any).Cookiebot)
        (window as any).Cookiebot?.renew();
    };

    return {
      provide: {
        cookieConsent: {
          // it will be populated in the `useCookieConsentScript` composable
          consent: cookieConsent,
          renew,
        },
      },
    };
  },
});
